<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox width">
          <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="年份" prop="year">
                <el-date-picker
                    v-model="formInline.year"
                    type="year"
                    value-format="yyyy"
                    placeholder="请选择">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="月份" prop="months">
                <el-select v-model="formInline.months"  filterable :placeholder="'--选择--'" clearable>
                  <el-option v-for="item in this.monthList"
                             :key="item.valut"
                             :label="item.name"
                             :value="item.valut">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销售人员" prop="cuname">
                <el-input v-model="formInline.cuname" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="客户编码/名称">
                <el-input v-model="formInline.soldToName" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="l-screenBox">
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="handleSearch">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="handleReset">重置</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="h-table h-mrt30 tableclslist">
        <el-table ref="ddtable"
                  :data="tableData"
                  border
                  :show-overflow-tooltip="true"
                  style="width: 100%"
                  max-height="450">
          <el-table-column
              prop="cuname"
              label="销售人员"
              width="160"
              fixed
              :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              prop="soldToName"
              label="客户名称"
              fixed
              width="220"
              :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              prop="soldToCode"
              label="客户编码"
              fixed
              width="220"
              :show-overflow-tooltip="true" >
          </el-table-column>
          <el-table-column
              prop="totalGscodePrice"
              label="订单金额"
              width="120"
              :show-overflow-tooltip="true">
            <template scope="scope">
              <div style="text-align: right;">
                {{scope.row.totalGscodePrice}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="wrbtr"
              label="回款金额"
              width="120"
              :show-overflow-tooltip="true">
            <template scope="scope">
              <div style="text-align: right;">
                {{scope.row.wrbtr}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="claimWrbtrs"
              label="认领金额"
              width="120"
              :show-overflow-tooltip="true">
            <template scope="scope">
              <div style="text-align: right;">
                {{scope.row.claimWrbtrs}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="didClaimWrbtrs"
              label="订单未认领金额"
              width="120"
              :show-overflow-tooltip="true">
            <template scope="scope">
              <div style="text-align: right;">
                {{scope.row.didClaimWrbtrs}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="year"
              label="年度"
              width="100"
              :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              prop="months"
              label="月度"
              width="100"
              :show-overflow-tooltip="true" >
            <template slot-scope="scope">
              {{monthList.filter(f => f.valut == scope.row.months)[0].name}}
            </template>
          </el-table-column>
<!--          <el-table-column
              prop="waers"
              label="货币类型"
              width="100">
          </el-table-column>-->
        </el-table>
        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
          <pagination :page="formInline" @query="query"/>
          <div style="display:flex;align-items: center;">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel()">批量导出
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ss from "@/api/SystemService";
  export default {
    data(){
      return{
        formInline: {
          year:null,//年
          months: null,//月份
          cuname: null,//销售人员
          soldToName: null,//客户编码/名称
          total: 0,
          pageSize: 10,
          pageNo: 1
        },
        monthList:[
          {valut:'01',name:'一月'},
          {valut:'02',name:'二月'},
          {valut:'03',name:'三月'},
          {valut:'04',name:'四月'},
          {valut:'05',name:'五月'},
          {valut:'06',name:'六月'},
          {valut:'07',name:'七月'},
          {valut:'08',name:'八月'},
          {valut:'09',name:'九月'},
          {valut:'10',name:'十月'},
          {valut:'11',name:'十一月'},
          {valut:'12',name:'十二月'},
        ],
        tableData: []
      }
    },
    created() {
      const date = new Date();
      let currentMonth = date.getMonth() + 1; // 注意月份是从0开始计数，所以需要加1
      let currentYear = date.getFullYear().toString();
      if (currentMonth < 10){
        currentMonth = '0' + currentMonth;
      }
      this.formInline.months = currentMonth;
      this.formInline.year = currentYear;
      this.query();
    },
    methods:{
      handleSearch(){   //查询
        this.formInline.pageNo = 1
        this.query()
      },
      handleReset(){  //重置
        const date = new Date();
        let currentMonth = date.getMonth() + 1; // 注意月份是从0开始计数，所以需要加1
        let currentYear = date.getFullYear().toString();
        if (currentMonth < 10){
          currentMonth = '0' + currentMonth;
        }
        this.formInline = {
          year:currentYear,//年
          months: currentMonth,//月份
          cuname: null,//销售人员
          soldToName: null,//客户编码/名称
          pageNo: 1,
          pageSize: 10,
          total: 0
        }
        this.query()
      },
      query(){
        ss.monthlyCollectionList.PaymentArrivePeoplePage(this.formInline).then(res=>{
          this.tableData = res.records;
          this.formInline.total = res.total || 0;
        })
      },
      exportExcel(){
        let param = {
          year:this.formInline.year,//年
          months: this.formInline.months,//月份
          cuname: this.formInline.cuname,//销售人员
          soldToName: this.formInline.soldToName,//客户编码/名称
        }
        ss.monthlyCollectionList.ExportPaymentPeopleList(param).then(res=>{
          const link = document.createElement('a')
          let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', `销售回款报表.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }).catch(function (error) {
           console.log("导出错误", error.toString())
        })
      }
    }
  }
</script>
<style>

</style>